import { createAsyncThunk } from "@reduxjs/toolkit";

import { getGoogleTranslateIntergration } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchGoogleTranslateIntergration = createAsyncThunk(
  "googleTranslate/fetchGoogleTranslateIntergration",
  async (
    params: Partial<{
      param: string;
      config: any;
    }>,
    { rejectWithValue, getState }
  ) => {
    const { param = "", config } = params;
    const { adapter } = getState() as AppState;

    const { baseUrl } = adapter.adapter;
    const { token } = fetchAuthToken(getState());

    try {
      const response = await getGoogleTranslateIntergration(
        token,
        baseUrl,
        param,
        config
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
